import { SvgIcon, useTheme } from '@mui/material';
import type { SvgIconProps } from '@mui/material';

export const RegistrationComplete = (props: SvgIconProps) => {
    const theme = useTheme();
    const color = theme.palette.success.main;

    return (
        <SvgIcon viewBox="0 0 24 24" focusable="false" aria-hidden htmlColor={color} {...props}>
            <svg
                width="94"
                height="87"
                viewBox="0 0 94 87"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g filter="url(#filter0_d_5234_13168)">
                    <circle cx="49.2207" cy="42.4917" r="36" fill={color} />
                </g>
                <circle opacity="0.5" cx="49.2207" cy="42.4917" r="41.5" stroke={color} />
                <rect
                    x="65.7197"
                    y="30.2637"
                    width="4"
                    height="32"
                    rx="2"
                    transform="rotate(45 65.7197 30.2637)"
                    fill="white"
                />
                <rect
                    x="48.6396"
                    y="52.8911"
                    width="4"
                    height="22.5133"
                    rx="2"
                    transform="rotate(135 48.6396 52.8911)"
                    fill="white"
                />
                <path
                    d="M86.929 2.88519C87.0963 2.46533 87.6906 2.46533 87.858 2.88519L89.1533 6.13554C89.2042 6.26306 89.3052 6.36408 89.4327 6.41491L92.683 7.71027C93.1029 7.8776 93.1029 8.47189 92.683 8.63922L89.4327 9.93458C89.3052 9.9854 89.2042 10.0864 89.1533 10.2139L87.858 13.4643C87.6906 13.8842 87.0963 13.8842 86.929 13.4643L85.6337 10.2139C85.5828 10.0864 85.4818 9.9854 85.3543 9.93458L82.1039 8.63922C81.6841 8.47189 81.6841 7.8776 82.1039 7.71027L85.3543 6.41491C85.4818 6.36408 85.5828 6.26306 85.6337 6.13554L86.929 2.88519Z"
                    fill={color}
                />
                <path
                    opacity="0.1"
                    d="M6.75586 65.5195C6.92319 65.0996 7.51748 65.0996 7.68481 65.5195L9.15513 69.2088C9.20595 69.3363 9.30697 69.4374 9.4345 69.4882L13.1238 70.9585C13.5437 71.1258 13.5437 71.7201 13.1238 71.8874L9.4345 73.3578C9.30697 73.4086 9.20595 73.5096 9.15513 73.6371L7.68481 77.3265C7.51748 77.7463 6.92319 77.7463 6.75586 77.3265L5.28554 73.6371C5.23472 73.5096 5.1337 73.4086 5.00618 73.3578L1.31683 71.8874C0.896974 71.7201 0.896973 71.1258 1.31683 70.9585L5.00618 69.4882C5.1337 69.4374 5.23472 69.3363 5.28554 69.2088L6.75586 65.5195Z"
                    fill={color}
                />
                <path
                    opacity="0.5"
                    d="M5.7254 11.447C5.92079 11.1307 6.38079 11.1307 6.57618 11.447L7.56697 13.051C7.60781 13.1171 7.66349 13.1728 7.7296 13.2136L9.33361 14.2044C9.64993 14.3998 9.64993 14.8598 9.33361 15.0552L7.7296 16.046C7.66349 16.0868 7.60781 16.1425 7.56697 16.2086L6.57618 17.8126C6.38079 18.1289 5.92079 18.1289 5.7254 17.8126L4.7346 16.2086C4.69377 16.1425 4.63809 16.0868 4.57198 16.046L2.96797 15.0552C2.65165 14.8598 2.65165 14.3998 2.96797 14.2044L4.57198 13.2136C4.63809 13.1728 4.69377 13.1171 4.7346 13.051L5.7254 11.447Z"
                    fill={color}
                />
                <defs>
                    <filter
                        id="filter0_d_5234_13168"
                        x="13.2207"
                        y="6.4917"
                        width="72"
                        height="80.2"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feMorphology
                            radius="9"
                            operator="erode"
                            in="SourceAlpha"
                            result="effect1_dropShadow_5234_13168"
                        />
                        <feOffset dy="12" />
                        <feGaussianBlur stdDeviation="2.6" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.0588235 0 0 0 0 0.466667 0 0 0 0 0.152941 0 0 0 0.25 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_5234_13168"
                        />
                        <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_5234_13168"
                            result="shape"
                        />
                    </filter>
                </defs>
            </svg>
        </SvgIcon>
    );
};
